<template lang="pug">
  .email-capture-modal
    CaptureModal(:modal-shown="emailModalShown" :close-modal-method="closeEmailModal")
      template(#header="")
        .title.upper.brand-color-1.bold.xs-f-xmedium.max-at-tweak {{subscribed ? config.title.success : config.title.default}}

      template(#content="")
        p.description.mb-20(v-if="subscribed" v-html="config.description.success")
        p.description.xs-mb-100m(v-else v-html="config.description.default")

        transition(name="fade")
          EmailCaptureForm(v-if="!subscribed" type="modal" :code="config.code" :email-source="config.email_source" @email-submitted="onEmailSubmitted")

        p.conditions.xs-f-xsmall.sm-f-xxsmall.max-at-tweak.xs-mt-75m(v-if="!subscribed" v-html="config.conditions")

</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import { getModalConfig } from '../utils';
  import CaptureModal from "../CaptureModal/CaptureModal";
  import EmailCaptureForm from "../EmailCaptureForm/EmailCaptureForm";

  import { PHONE_CAPTURE_EXPERIMENT} from "../constants";

  export default {
    name: 'EmailCaptureModal',

    components: {
      EmailCaptureForm,
      CaptureModal,
    },

    data: () => ({
      experimentVariation: null,
      phoneCaptureExperiment: null
    }),

    computed: {
      ...mapState('emailCapture', [
        'emailModalShown',
        'subscribed',
      ]),

      ...mapState('customer', [
        'cdata',
      ]),

      config() {
        return getModalConfig();
      },
    },

    mounted() {
      this.phoneCaptureExperiment = window.experiments[PHONE_CAPTURE_EXPERIMENT];

      if (this.phoneCaptureExperiment) {
        this.mix_trackExperimentViewed(PHONE_CAPTURE_EXPERIMENT);
      }
    },

    methods: {
      ...mapActions('emailCapture', [
        'closeEmailModal',
        'openPhoneModal',
        'runPhoneCapture'
      ]),

      onEmailSubmitted() {
        if (this.phoneCaptureExperiment === 'B') {
          this.closeEmailModal();
          setTimeout(() => {
            this.runPhoneCapture({ cdata: this.cdata });
          }, 800);
        }
      },
    },
  };
</script>

<style lang="stylus">
  .email-capture-modal > .capture-modal
    padding-bottom 60px
</style>